module.exports = __webpack_public_path__ + "Simple-Line-Icons.2fe2efe63441d830b1ac.svg";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/simple-line-icons/Simple-Line-Icons.svg?v=2.4.0
// module id = ../../../../../src/assets/fonts/simple-line-icons/Simple-Line-Icons.svg?v=2.4.0
// module chunks = 40